import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { useMemo } from 'react';
import { InformationIcon, CheckmarkBackgroundIcon, WarningIcon, CriticalIcon } from '@paypalcorp/pp-react-icons';
import { css, useTheme, jsx } from '@emotion/react';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { textStyles } from '@paypalcorp/pp-react-text';

var _templateObject, _templateObject2, _templateObject3;

function styles(tokens) {
  /* istanbul ignore next */
  if (!Object.keys(tokens).length) {
    console.warn('Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react.');
    return {};
  }

  var sysSpaceSm = tokens.sysSpaceSm,
      sysSpaceLg = tokens.sysSpaceLg,
      sysSizeIconXs = tokens.sysSizeIconXs;

  var _textStyles = textStyles(tokens),
      textCaption = _textStyles.caption;

  var base = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    label: contextual-alert_base;\n    display: flex;\n    padding: ", " 0;\n    ", "\n  "])), sysSpaceLg, textCaption());
  var statusIcon = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    label: status_icon;\n    margin-top: ", ";\n    margin-right: ", ";\n    height: ", ";\n\n    [dir='rtl'] & {\n      margin-left: ", ";\n      margin-right: 0;\n    }\n  "])), '0.0625rem', sysSpaceSm, sysSizeIconXs, sysSpaceSm);
  var noPadding = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    label: no_padding;\n    padding: 0;\n  "])));
  return {
    base: base,
    statusIcon: statusIcon,
    noPadding: noPadding
  };
}

var _excluded = ["className", "type", "typeIconAriaLabel", "children", "noPadding"];
var iconMap = {
  info: InformationIcon,
  success: CheckmarkBackgroundIcon,
  warning: WarningIcon,
  error: CriticalIcon
};

var ContextualAlert = function ContextualAlert(_ref) {
  var className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'info' : _ref$type,
      _ref$typeIconAriaLabe = _ref.typeIconAriaLabel,
      typeIconAriaLabel = _ref$typeIconAriaLabe === void 0 ? type : _ref$typeIconAriaLabe,
      children = _ref.children,
      _ref$noPadding = _ref.noPadding,
      noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding,
      rest = _objectWithoutProperties(_ref, _excluded);

  var tokens = useTheme();

  var _styles = useMemo(function () {
    return styles(tokens);
  }, [tokens]);

  var iconCssVal = _styles.statusIcon;
  var StatusIcon = iconMap[type];
  var baseCSS = [_styles.base, noPadding && _styles.noPadding];
  return jsx("div", _extends({
    role: "alert",
    css: baseCSS,
    className: className,
    "data-ppui-info": "contextual-alert_3.1.2"
  }, rest), jsx(StatusIcon, {
    css: iconCssVal,
    size: "xs",
    color: {
      info: 'sysColorInfoContrast',
      success: 'sysColorSuccessMain',
      warning: 'sysColorWarningAlt',
      error: 'sysColorErrorMain'
    }[type],
    role: "img",
    "aria-label": typeIconAriaLabel,
    "data-ppui": "true"
  }), children);
};

export { ContextualAlert, styles as contextualAlertStyles };